import { render } from "./SetCookie.vue?vue&type=template&id=5d7bd0bb&scoped=true"
import script from "./SetCookie.vue?vue&type=script&lang=js"
export * from "./SetCookie.vue?vue&type=script&lang=js"

import "./SetCookie.vue?vue&type=style&index=0&id=5d7bd0bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7bd0bb"]])

export default __exports__